enum BusinessPartnerConstants {
  FOREST_AND_GARDEN = 'FOREST_AND_GARDEN',
  CONSTRUCTION = 'CONSTRUCTION',
}

export default BusinessPartnerConstants;
